export const fontSize = 22;
export const strokeWidth = 4;
export const ballDefaultWidth = 18;
